import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/** Sinf tanlovi (Select) uchun minimal ko'rinish */
export interface ClassOpt { id: string; name: string }

/** Fan tanlovi (Select) uchun minimal ko'rinish */
export interface SubjectOpt { id: string; name: string }

/** O'quv yili (GET /classes/academic-years) */
export interface AcademicYearOpt { id: string; name: string; isActive?: boolean }

/** Oylik tushum nuqtasi (GET /reports/revenue) */
export interface RevenuePoint {
  month: string;
  /** Oy daromadi — shu oy UCHUN to'langan (`forMonth`) */
  total: number;
  /** Kassa tushumi — shu oy ICHIDA kassaga tushgan (`paidAt`) */
  cash: number;
}

/**
 * Sinflar ro'yxati — barcha sahifalar bitta keshni bo'lishadi (har sahifada
 * nusxa so'rov yozish shart emas). `enabled=false` — so'rov kechiktiriladi
 * (masalan, modal ochilguncha).
 *
 * Kesh kaliti FOYDALANUVCHIGA bog'langan: backend o'qituvchiga faqat o'zi dars
 * beradigan sinflarni qaytaradi, shuning uchun akkaunt almashganda oldingi
 * foydalanuvchining ro'yxati qolib ketmasligi kerak.
 */
export function useClasses(enabled = true) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['classes', user?.id],
    queryFn: async () => (await api.get<ClassOpt[]>('/classes')).data,
    enabled,
  });
}

/**
 * Fanlar ro'yxati — `useClasses` bilan bir xil uslub: barcha sahifalar bitta
 * keshni bo'lishadi, sahifada nusxa `useQuery(['subjects'])` yozilmaydi.
 * `enabled=false` — so'rov kechiktiriladi (masalan, modal ochilguncha).
 *
 * Kesh kaliti FOYDALANUVCHIGA bog'langan (akkaunt almashganda eski ro'yxat
 * qolib ketmasligi uchun) — `useClasses` dagi sabab bilan bir xil.
 */
export function useSubjects(enabled = true) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['subjects', user?.id],
    queryFn: async () => (await api.get<SubjectOpt[]>('/subjects')).data,
    enabled,
  });
}

/**
 * O'quv yillari — `QuickCreate.tsx` dagi ichki so'rov bilan AYNAN bir xil kesh
 * kaliti (`['academic-years']`) ishlatiladi: yangi yil qo'shilganda ikkala joy ham
 * bir vaqtda yangilanadi.
 */
export function useAcademicYears(enabled = true) {
  return useQuery({
    queryKey: ['academic-years'],
    queryFn: async () => (await api.get<AcademicYearOpt[]>('/classes/academic-years')).data,
    enabled,
  });
}

/**
 * Yillik oylik tushum — yagona ["revenue", year] key: Dashboard, Payments va
 * Reports bitta so'rov natijasini bo'lishadi (avval 3 xil key ishlatilgan).
 */
export function useRevenue(year: string, enabled = true) {
  return useQuery({
    queryKey: ['revenue', year],
    queryFn: async () =>
      (await api.get<RevenuePoint[]>('/reports/revenue', { params: { year } })).data,
    enabled,
  });
}
